// extracted by mini-css-extract-plugin
module.exports = {"tag-popup-container":"tag-edit-popup_tag-popup-container__GNWjR","tag-every":"tag-edit-popup_tag-every__hOG78","tag-part":"tag-edit-popup_tag-part__1t6wy"};